<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="title" :className="pageType" :noCloseOnEsc="true")
    b-container(fluid)
      .context
        b-table.type-2.mb-3(
          ref="table"
          :fields="tableData.fields"
          :items="fetchList"
          :empty-text="$t('no_data_available')"
          show-empty
          responsive
        )
          template(v-slot:cell(btn)="row")
            b-link(size="sm" @click="selectDelete([row.item])") #[span.svg-icon.trash delete]
    .modal-footer()
      b-button(variant="secondary" size="sm" @click="close" pill) {{$t('submit')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"
import LoginStatusCheckAPI from "@/api/login-status-check";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Dialogs,
    ConfirmDialogs,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      if (newVal) {
        this.pk = this.$route.query.pk
        this.errorCode = this.$route.query.errorCode
      }
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      title: this.$t('dialogs_page.user_environment_check_result'),
      visible: false,
      loadingSubmit: false,
      pageType: "type-layer",
      pk: null,
      errorCode: "",
      tableData: {
        fields: [
          { key: "title", label: this.$t('dialogs_page.inspection_item'), thStyle: { minWidth: "130px" } },
          { key: "comment", label: this.$t('dialogs_page.description'), thStyle: { minWidth: "150px" } },
          { key: "result", label: this.$t('dialogs_page.result'), thStyle: { minWidth: "130px" } },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.name === "popup-status-check") {
      this.$nextTick(() => {
        this.pageType = "type-popup"
        this.visible = true
      })
    }
  },
  methods: {
    fetchList() {
      let params = {
        pk: this.pk,
        errorCode: this.errorCode,
      }
      return LoginStatusCheckAPI.get("login_status_check", {params}).then(res => {
        const { objects } = res.data
        this.tableData.list = objects
        return this.tableData.list
      })
    },
    close() {
      if (this.$route.name === "popup-status-check") {
        window.close()
        return
      }
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #000000;
  background-color: #f5f5f5;
  line-height: 41px;
  padding-left: 2px;
  margin-bottom: 20px;
  &::before {
    content: "";
    display: inline-block;
    margin: 0 8px;
    width: 1px;
    height: 21px;
    background-color: #000000;
  }
}
.form-wrap {
  padding-bottom: 10px;

  &.columns {
    display: flex;
    align-items: center;
    label {
      position: relative;
      padding-left: 8px;
      font-size: 15px;
      color: #000000;
      font-weight: 500;
      margin: 0 15px;
      span {
        padding-right: 10px;
      }
      em {
        font-style: normal;
        padding-left: 8px;
        animation: blink 1s infinite;
      }
    }
  }
}

.context > .warning {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  padding: 20px 0 0;
  &.limit {
    svg {
      margin-bottom: 15px;
    }
  }
  i {
    color: #c8c8c8;
    margin-bottom: 20px;
  }
}

@keyframes blink {
  0%,
  100% {
    color: black;
  }
  50% {
    color: red;
  }
}
::v-deep {
  .form-row.form-group {
    margin-bottom: 3px;
    margin-left: 12px;
    > label {
      &::after {
        display: none;
      }
    }
  }
  .delete svg {
    color: #b1b1b1;
  }
}
</style>
